import { Card, Col, Container, Row } from 'react-bootstrap'
import ArrowIcon from '@assets/icons/arrow-card-icon.svg'

import Icon from '@atk/components/icon'

import FramerMotion from '@atk/hooks/framerMotion'

import styles from './CardHorizontal4.module.scss'

type ItemsProps = {
    title?: string
    desc?: string
    bgColor?: string
}

export type CardHorizontal4DefaultProps = {
    sectionTitle?: string
    sectionDesc?: string
    customClass?: string
    hasArrow?: boolean
    items: ItemsProps[]
}

export default function CardHorizontal4({
    sectionTitle,
    sectionDesc,
    customClass,
    hasArrow,
    items,
}: CardHorizontal4DefaultProps) {
    const componentClass = `CardHorizontal4 ${styles.CardHorizontal4} ${customClass ?? ''}`

    return (
        <section className={componentClass}>
            <Container>
                <h2 className="mb-5" dangerouslySetInnerHTML={{ __html: sectionTitle ?? '' }}></h2>
                {sectionDesc && <p className="mb-5">{sectionDesc}</p>}
                <Row>
                    {items?.map((item: ItemsProps, index: number) => (
                        <Col className="mb-4 position-relative" md={6} lg={4} key={index}>
                            <FramerMotion key={index}>
                                <Card style={{ backgroundColor: `${item.bgColor}` }} className={styles.card}>
                                    <Card.Body className={styles.cardBody}>
                                        <p className="title">{item.title}</p>
                                        <p className="desc"> {item.desc}</p>
                                        {hasArrow && (
                                            <div className="open-arrow position-absolute">
                                                <Icon source={ArrowIcon.src} />
                                            </div>
                                        )}
                                    </Card.Body>
                                </Card>
                            </FramerMotion>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    )
}
